import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import Header from '../../components/header/header';
import PageLoader from '../../components/page-loader/page-loader';
import CmsSectionVisibility from '../../components/cms-section-visibility/cms-section-visibility';
import './speaking.scss';

interface SpeakingPageOptions {
  debug?: boolean;
  [key: string]: any;
}

class SpeakingPage extends Base {
  private header: Header;

  private loader: PageLoader;

  private cmsSectionVisibility: CmsSectionVisibility;

  constructor(options: SpeakingPageOptions = {}) {
    super(options.debug || false);
    this.debug = options.debug || false;

    this.header = new Header({ debug: this.debug });
    this.loader = new PageLoader({
      debug: this.debug,
      oncePerPageSession: true,
      pageKey: window.location.pathname,
    });

    this.cmsSectionVisibility = new CmsSectionVisibility({
      debug: this.debug,
      collectionId: '69a1e302575d6c2f61ddc96b',
      sectionMap: {
        'speaking-page---recent-highlights': '#speaking-highlights',
        'speaking-page---booking-information': '#booking-information'
      }
    });

    this.init();
  }

  init(): void {
    this.loader.start();
    this.log('SpeakingPage initialized');
  }
}

onReady(() => {
  new SpeakingPage({ debug: true });
});

export default SpeakingPage;
